module.exports = __webpack_public_path__ + "img/西甲联盟@2x.49057e2f.png";